export const fragSamplerTint = `
precision mediump float;

uniform sampler2D uSampler0;
varying vec2 outTexCoord;

uniform vec3 uTintColour;

// {{colourRegionMaskUniforms}}

void main ()
{
  vec4 texColourToShade = texture2D(uSampler0, outTexCoord);
  
  // {{colourRegionMaskCheck}}
  
  float normTint = max(0.001, 0.30 * uTintColour.r + 0.59 * uTintColour.g + 0.11 * uTintColour.b);
  vec3  mixColor = uTintColour * texColourToShade.rgb / normTint;
  
  gl_FragColor = vec4(mixColor.rgb, texColourToShade.a);

  // {{colourRegionMaskShade}}
}
`;
